// src/layouts/portfolio/index.jsx

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import Footer from "examples/Footer";
import PortfolioModal from "./components/PortfolioModal";

// Função de estilo global para os Botões
const chipStyle = (selected) => (theme) => ({
  backgroundColor: selected ? "#A3E635" : "#2A2B3D",
  color: selected ? "#141727" : "#FFFFFF",
  fontWeight: "bold",
  cursor: "pointer",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center", // ← vertical
  justifyContent: "center", // ← horizontal
  height: theme.spacing(5), // ← define altura consistente
  px: 1.5, // ← padding horizontal (left/right)
  borderRadius: theme.shape.borderRadius * 2, // ← borda arredondada mais forte
  "&:hover": {
    backgroundColor: selected ? "#B7F961" : "#3B3C4F",
    color: selected ? "#141727" : "#E0E0E0",
  },
});

const publicImg = (file) => `${process.env.PUBLIC_URL}/assets/img/${file}`;
const publicPdf = (file) => `${process.env.PUBLIC_URL}/assets/pdfs/${file}`;
const publicVideo = (file) => `${process.env.PUBLIC_URL}/assets/video/${file}`;
// Exemplos de URLs em pastas de /IMG

const portfolioItems = [
  {
    title: "Revista Home Theater & Casa Digital",
    category: "Design Gráfico",
    image: publicImg("ht&cd/cards-miniaturas-480-capa.webp"),
    description: "Projeto editorial completo: capas, diagramação e arte para impressão gráfica.",
    descriptionLong: `
      Diagramação e direção de arte da revista HT&CD, com criação de capas, páginas internas,
      edição de imagens, ilustrações e preparação de arquivos finais para impressão.
      Projeto desenvolvido em conjunto com jornalistas e redatores especializados.
    `,
    stackNote: `
      Stack utilizada: pacote completo Adobe (Photoshop, Illustrator, InDesign), além de QuarkXPress para diagramação e layout editorial, Adobe Distiller e Acrobat para fechamento de arquivos em PDF com padrão gráfico profissional. O fluxo envolveu edição e tratamento de imagens, criação de ilustrações, design de capas, projeto gráfico e finalização para impressão offset. Ferramentas amplamente utilizadas no mercado editorial até 2025, garantindo qualidade visual, precisão técnica e compatibilidade com gráficas especializadas.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior
    assets: {
      criativo: [
      publicImg("ht&cd/revistaht&cd-capa.webp"),  
      publicImg("ht&cd/revistaht&cd-pag1.webp"),
      publicImg("ht&cd/revistaht&cd-pag2.webp"),
      publicImg("ht&cd/revistaht&cd-pag3.webp"),
      publicImg("ht&cd/revistaht&cd-pag4.webp"),
      publicImg("ht&cd/revistaht&cd-pag5.webp"),
      publicImg("ht&cd/revistaht&cd-pag6.webp"),
      publicImg("ht&cd/revistaht&cd-pag7.webp"),
      publicImg("ht&cd/revistaht&cd-pag8.webp"),
      ],
    },
  },
  {
    title: "Revista Home Theater Best",
    category: "Design Gráfico",
    image: publicImg("best/cards-miniaturas-480-best.webp"),
    description: "Projeto editorial completo: capas, diagramação e arte para impressão gráfica.",
    descriptionLong: `
      Diagramação e direção de arte da revista Home Theater Best, com criação de capas, páginas internas,
      edição de imagens, ilustrações e preparação de arquivos finais para impressão.
      Projeto desenvolvido em conjunto com jornalistas e redatores especializados.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe completo (Photoshop, Illustrator, InDesign) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, com aplicação de marcas de corte, sangrias e separações para cores especiais e verniz localizado. Projeto preparado para impressão offset em gráfica especializada, com foco em acabamento premium: papel couchê de alta gramatura, brilho, reserva de verniz e cores especiais na capa.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior
    assets: {
      criativo: [
      publicImg("best/best-capas-abre.webp"),  
      publicImg("best/best-dupla-pag1.webp"),
      publicImg("best/best-dupla-pag2.webp"),
      publicImg("best/best-dupla-pag3.webp"),
      publicImg("best/best-dupla-pag4.webp"),
      publicImg("best/best-dupla-pag5.webp"),
      publicImg("best/best-dupla-pag6.webp"),
      publicImg("best/best-dupla-pag7.webp"),
      ],
    },
  },
  {
    title: "Publicidade",
    category: "Design Gráfico",
    image: publicImg("publicidade/cards-miniaturas-480-publicidade.webp"),
    description: "Criação de peças publicitárias para campanhas impressas e digitais.",
    descriptionLong: `
      Desenvolvimento de anúncios, folders, cartazes e criativos digitais com foco em impacto visual e mensagem clara.
    Projetos voltados para mídia impressa e redes sociais, alinhando identidade da marca com objetivos comerciais.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe completo (Photoshop, Illustrator, InDesign) e QuarkXPress para estruturação editorial e layout. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, com aplicação de marcas de corte e sangrias. Impressão offset em gráfica.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior
    assets: {
      criativo: [
      publicImg("publicidade/publicidade-pg1.webp"),  
      publicImg("publicidade/publicidade-pg2.webp"),
      publicImg("publicidade/publicidade-pg3.webp"),
      publicImg("publicidade/publicidade-pg4.webp"),
      publicImg("publicidade/publicidade-pg5.webp"),
      publicImg("publicidade/publicidade-pg6.webp"),
      publicImg("publicidade/publicidade-pg7.webp"),
      ],
    },
  },
  {
    title: "Publicação Institucional Samsung",
    category: "Design Gráfico",
    image: publicImg("samsung/cards-miniaturas-480-samsung.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("samsung/samsung-capa.webp"),
      publicImg("samsung/samsung-pag1.webp"),
      publicImg("samsung/samsung-pag2.webp"),
      publicImg("samsung/samsung-pag3.webp"),
      publicImg("samsung/samsung-pag4.webp"),
      publicImg("samsung/samsung-pag5.webp"),
      publicImg("samsung/samsung-pag6.webp"),
      publicImg("samsung/samsung-pag7.webp"),
      publicImg("samsung/samsung-pag8.webp"),
      publicImg("samsung/samsung-pag9.webp"),               
      ],
    },
  },
  {
    title: "Publicação Institucional NET/Claro",
    category: "Design Gráfico",
    image: publicImg("net/cards-miniaturas-480-net.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("net/capa-net-institucional-abre2.webp"),
      publicImg("net/capa-net-institucional-pg1.webp"),
      publicImg("net/capa-net-institucional-pg2.webp"),
      publicImg("net/capa-net-institucional-pg3.webp"),
      publicImg("net/capa-net-institucional-pg4.webp"),
      publicImg("net/capa-net-institucional-pg5.webp"),
      publicImg("net/capa-net-institucional-pg6.webp"),
      ],
    },
  },
  {
    title: "Publicação Institucional Panasonic",
    category: "Design Gráfico",
    image: publicImg("panasonic/cards-miniaturas-480-panasonic.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("panasonic/panasonic-capa.webp"),
      publicImg("panasonic/panasonic-pag1.webp"),
      publicImg("panasonic/panasonic-pag2.webp"),
      publicImg("panasonic/panasonic-pag3.webp"),              
      ],
    },
  },
  {
    title: "Publicação Institucional Audiogene",
    category: "Design Gráfico",
    image: publicImg("audiogene/cards-miniaturas-480-capa.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("audiogene/audiogene-capa.webp"),
      publicImg("audiogene/audiogene-pag1.webp"),
      publicImg("audiogene/audiogene-pag2.webp"),
      publicImg("audiogene/audiogene-pag3.webp"),
      publicImg("audiogene/audiogene-pag4.webp"),
      ],
    },
  },
  {
    title: "Publicação Institucional Roehn",
    category: "Design Gráfico",
    image: publicImg("roehn/cards-miniaturas-480-roehn.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("roehn/roehn-capa.webp"),
      publicImg("roehn/roehn-pg1.webp"),
      publicImg("roehn/roehn-pg2.webp"),
      publicImg("roehn/roehn-pg3.webp"),
      publicImg("roehn/roehn-pg4.webp"),
      ],
    },
  },
  {
    title: "Publicação Institucional Sony",
    category: "Design Gráfico",
    image: publicImg("sony/cards-miniaturas-480-sony.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("sony/sony-capa.webp"),
      publicImg("sony/sony-pag1.webp"),
      publicImg("sony/sony-pag2.webp"),
      publicImg("sony/sony-pag3.webp"),
      publicImg("sony/sony-pag4.webp"),      
      ],
    },
  },
  {
    title: "Publicação Institucional LG",
    category: "Design Gráfico",
    image: publicImg("lg/cards-miniaturas-480-lg.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("lg/lg-capa.webp"),
      publicImg("lg/lg-pag1.webp"),
      publicImg("lg/lg-pag2.webp"),
      publicImg("lg/lg-pag3.webp"),
      publicImg("lg/lg-pag4.webp"),
      publicImg("lg/lg-pag5.webp"),
      publicImg("lg/lg-pag6.webp"),
      publicImg("lg/lg-pag7.webp"),          
      ],
    },
  },
  {
    title: "Publicação Institucional Livro da Liga",
    category: "Design Gráfico",
    image: publicImg("liga/cards-miniaturas-480-liga.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("liga/liga-capa.webp"),
      publicImg("liga/liga-pag1.webp"),
      publicImg("liga/liga-pag2.webp"),
      publicImg("liga/liga-pag3.webp"),
      publicImg("liga/liga-pag4.webp"),                
      ],
    },
  },
  {
    title: "Publicação Institucional Savant",
    category: "Design Gráfico",
    image: publicImg("savant/cards-miniaturas-480-savant.webp"), // net/capa-net-institucional1.webp
    description: "Diagramação formato revista para impressão gráfica. Edição de arte e projeto gráfico.",
    descriptionLong: `
      Diagramação, criação de capa, páginas internas, edição e tratamento de imagens, ilustrações e fechamento de arquivos para impressão.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Photoshop, Illustrator, Acrobat) e QuarkXPress para estruturação editorial e diagramação profissional. Utilização de Adobe Distiller e Acrobat para fechamento técnico de arquivos PDF em alta resolução, aplicação de marcas de corte e sangrias com separações de cores em CMYK. Projeto preparado para impressão offset em gráfica especializada.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior  Campanha LinkedIn Ads
    assets: {
      criativo: [
      publicImg("savant/savant-pag1.webp"),
      publicImg("savant/savant-pag2.webp"),
      publicImg("savant/savant-pag3.webp"),
      publicImg("savant/savant-pag4.webp"),
      publicImg("savant/savant-pag5.webp"),                      
      ],
    },
  },
  {
    title: "Campanha LinkedIn Ads",
    category: ["Landing Pages", "Marketing Digital"],
    image: publicImg("likepi/cards-miniaturas-480-likepi.webp"), // likepi/cards-miniaturas-480-likepi.webp
    description: "Campanha direcionada a arquitetos para impulsionar vendas B2B em automação residencial.",
    descriptionLong: `
      Projeto para a Like Pi Domótica com foco em diversificação de vendas.
      Estratégia voltada a arquitetos e escritórios de arquitetura — principais tomadores de decisão — por meio do LinkedIn Ads.
      Landing Page segmentada com copywriting persuasivo e material PDF profissional com apresentação interativa da empresa e seus produtos.
      Resultado: aumento expressivo no número de leads e faturamento via novos canais além dos lojistas tradicionais.
    `,
    assets: {
      landingPage: publicImg("likepi/Landing-Page-LikePi-Arquitetos_desktop.webp"),
      pdfPortifolio: publicPdf("catalogo-produtos-likepi.pdf"),
      catalogoSlides: [ // 🔵 Aqui adicionamos o novo carrossel
        publicImg("likepi/catalogo/catalogo-likepi-pag1.webp"),
        publicImg("likepi/catalogo/catalogo-likepi-pag2-3.webp"),
        publicImg("likepi/catalogo/catalogo-likepi-pag4-5.webp"),
        publicImg("likepi/catalogo/catalogo-likepi-pag6-7.webp"),
        publicImg("likepi/catalogo/catalogo-likepi-pag8-9.webp"),
        publicImg("likepi/catalogo/catalogo-likepi-pag10-11.webp"),
        publicImg("likepi/catalogo/catalogo-likepi-pag12.webp"),
      ],
    },
  },  
  // {
    // title: "Landing Page React",
    // category: "Web / UI",
    // image: publicImg("landing-ui.png"),
    // description: "Landing page moderna com React e Tailwind.",
  // },
  {
    title: "Micro SaaS Agenda/Calendário",
    category: ["Micro SaaS", "Web / UI", "IA e Automações"],
    image: publicImg("saas/capa-saas-microsaas.webp"),
    description: "Sistema de agendamento inteligente com dashboard personalizado.",
    descriptionLong: `
      Solução desenvolvida para professores de idiomas autônomos, freelancers ou empreendedores que buscam um sistema completo de gestão escolar com foco em agilidade, autonomia e organização.
      A plataforma modular resolve uma lacuna importante deixada por ferramentas como o Google Agenda, que não oferecem relatórios com status detalhado de aulas para alunos e professores. O sistema permite o cadastro e gerenciamento de alunos, professores e agendamentos de aulas por meio de um calendário interativo e dinâmico. Inclui funcionalidades como emissão de relatórios, controle de presença, listagens, filtros e comunicação interna por chat.
      Conta com três níveis de acesso por login (administrador, professor e aluno), com interface amigável e comunicação entre os módulos via banco de dados unificado.
      O grande diferencial da plataforma é a integração com inteligência artificial. A IA atua como uma professora assistente disponível 24 horas por dia, 7 dias por semana, gerando automaticamente exercícios de gramática com base no histórico de aulas e nas necessidades do aluno. Isso amplia a experiência de aprendizado e permite acompanhar a evolução dos alunos com base no desempenho nos exercícios e nas aulas.
    `,
    stackNote: `
      Stack utilizada: frontend com Bootstrap customizado, jQuery e Ajax (.com.br), painel administrativo integrado ao backend PHP (Laravel) e banco de dados MySQL acessado via phpMyAdmin. Utiliza FullCalendar para agendamento de aulas e IA integrada via FastAPI e OpenAI GPT-3.5 Turbo para geração personalizada de exercícios, avaliação de desempenho e orientação pedagógica contínua. Arquitetura modular com documentação completa e estrutura escalável.
    `,
    assets: {
      criativo: [
      publicImg("saas/saas-login-1.webp"),
      publicImg("saas/saas-dashboard-2.webp"),
      // publicImg("saas/saas-users-3.webp"),
      publicImg("saas/saas-menu-person-4.webp"),
      publicImg("saas/saas-alunos-colors-5.webp"),
      // publicImg("saas/saas-alunos-cadastro-6.webp"),
      // publicImg("saas/saas-alunos-tabela-7.webp"),
      // publicImg("saas/saas-aulas-cadastro-8.webp"),
      publicImg("saas/saas-aulas-cadastro-9.webp"),
      publicImg("saas/saas-aulas-altera-modal-10.webp"),
      // publicImg("saas/saas-aulas-tabela-11.webp"),
      publicImg("saas/saas-aulas-tabela-edit-12.webp"),
      publicImg("saas/saas-aulas-pesquisa-13.webp"),
      // publicImg("saas/saas-financ-calend-14.webp"),
      // publicImg("saas/saas-financ-calend-15.webp"),
      publicImg("saas/saas-chat-16.webp"),
      publicImg("saas/saas-alerts-17.webp"),
      publicImg("saas/saas-calend-semana-18.webp"),
      publicImg("saas/saas-calendario-compromissos-19.webp"),
      publicImg("saas/saas-notificacoes-20.webp"),
      publicImg("saas/21-saas-notificacoes-21.webp"),
      ],
    },
  },
  {
    title: "Branding", // Criação de logomarcas - branding
    category: ["Design Gráfico", "Marketing Digital"],
    image: publicImg("branding/cards-miniaturas-480-branding.webp"),
    description: "Criação de logomarcas profissionais com foco estratégico, visual marcante e aplicação versátil.",
    descriptionLong: `
      Desenvolvimento de logomarcas e identidades visuais que traduzem com clareza a essência de marcas, produtos ou serviços. O processo de criação envolve pesquisa de mercado, análise de concorrência, estudo de tipografia, paleta de cores e simbologia, garantindo um resultado alinhado ao posicionamento e propósito da marca.
    `,
    stackNote: `
      Stack utilizada: pacote Adobe (Illustrator, Photoshop, InDesign) para criação e finalização dos elementos gráficos. As apresentações foram entregues em formatos diversos (JPG, PNG com fundo transparente, PDF e mockups para visualização), além de arquivos vetoriais (AI, EPS, SVG) e manual de identidade visual em PDF com orientações completas sobre uso do logotipo, paleta cromática, tipografia e construção visual.
    `,
    modalSize: "widescreen", // <- esta linha ativa o layout maior 1024px, se retirar ativa o quadrado 960px
    assets: {
      criativo: [
        publicImg("branding/branding-1-likepi.webp"),
        publicImg("branding/branding-2-vivart.webp"),
        publicImg("branding/branding-3-vimarc.webp"),
        publicImg("branding/branding-4-perfecto.webp"),
        publicImg("branding/branding-5-btech.webp"),
        publicImg("branding/branding-6-ht&cd.webp"),
        publicImg("branding/branding-7-htpremium.webp"),
        publicImg("branding/branding-8-htbest.webp"),
        publicImg("branding/branding-9-event.webp"),        
      ],
    },
  },
  {
    title: "Campanha Meta Ads – Instagram + Landing Page",
    category: ["Landing Pages", "Marketing Digital"],
    image: publicImg("perfecto/instagram/cards-miniaturas-480-capa-feed.webp"),
    description: "Campanha A/B com foco em captação de leads qualificados para cursos de espanhol.",
    descriptionLong: `
      Criação de campanha para Instagram Ads da escola Perfecto Espanhol, com criativos otimizados em formato Feed e direcionamento para landing page com alta taxa de conversão. A estratégia incluiu testes A/B com mensagens distintas para públicos iniciantes, utilizando segmentação por interesse e comportamento. A landing page foi construída como página estática para garantir carregamento rápido, SEO eficiente e responsividade, otimizando o desempenho da campanha e a experiência do usuário.
    `,
    stackNote: `
      Frontend desenvolvido com Next.js, ideal para campanhas de performance devido ao suporte nativo a SEO, renderização híbrida (SSR e SSG) e excelente velocidade de carregamento. Hospedado na Vercel, plataforma recomendada para projetos otimizados com integração contínua (CI/CD). A escolha desta stack contribuiu para reduzir o custo por clique (CPC) e aumentar a taxa de conversão na base do funil.
    `,
    assets: {
      landingPreview: publicImg("perfecto/instagram/perfecto-instagram-feed-lp1.webp"),  // preview leve
      landingFull: publicImg("perfecto/instagram/perfecto-instagram-feed-lp1-big.webp"),        // imagem full
      // landingPage: publicImg("landing-likepi.webp"),
      // pdfPortifolio: publicPdf("portfolio-likepi.pdf"),
      criativo: [publicImg("perfecto/instagram/perfecto-instagram-feed1.webp")],
    },
  },
  {
    title: "Site com Gateway de Pagamento",
    category: ["Web / UI", "IA e Automações"],
    image: publicImg("perfecto/cards-miniaturas-480-siteperfecto.webp"),
    description: "Site com estrutura moderna, gateway de pagamento e UX otimizado.",
    descriptionLong: `
      Este projeto foi desenvolvido para a Perfecto Espanhol, com o objetivo de oferecer uma experiência fluida, segura e intuitiva ao usuário na hora da compra. A estrutura combina layout responsivo, gateway de pagamento transparente e comunicação direta com banco de dados e e-mail.
      Toda a interface foi personalizada com foco em UX, apresentando os cursos e benefícios da escola com clareza, agilidade e confiança. A automação do processo de pagamento garante rapidez na aprovação e segurança nos dados transmitidos.
    `,
    stackNote: `
    Stack utilizada: Bootstrap customizado no frontend e backend em LAMP (Linux, Apache, MySQL, PHP), com sistema de pagamento integrado via WordPress, WooCommerce e Asaas. Automação de formulário conectado ao banco de dados MySQL, com envio automático de e-mails autenticados por SendGrid e roteados via DNS no servidor. Projeto hospedado com redirecionamento para o domínio .app, com layout do e-commerce estilizado por Elementor Pro.
    `,
    assets: {
      sitePreview: publicImg("perfecto/site-abre-desktop-mobile.webp"),   // imagem leve
      siteFull: publicImg("perfecto/site-abre-desktop-big.webp"),        // imagem maior
      externalUrl: "https://www.perfectoespanhol.com.br",
    },    
  },
  {
    title: "Landing Page para Google Ads", 
    category: ["Landing Pages", "Marketing Digital"],
    image: publicImg("perfecto/google/cards-miniaturas-480-google2.webp"),
    description: "Página otimizada para Google Ads com foco em leads qualificados e alta conversão.",
    descriptionLong: `
      Landing page desenvolvida para campanha no Google Ads da escola Perfecto Espanhol, com foco em conversão na base do funil. 
      Estrutura enxuta, responsiva e orientada à ação, com copy persuasiva e aplicação estratégica de palavras-chave de alta intenção. 
      Projetada para atrair leads qualificados interessados em cursos de espanhol, gerando alta taxa de conversão com redução significativa no custo por clique (CPC).
    `,
    stackNote: `
      Stack utilizada: Next.js com renderização estática (SSG) para garantir velocidade de carregamento, SEO técnico otimizado e performance superior. Hospedagem em Vercel, ideal para projetos com foco em marketing digital, escalabilidade e integração contínua (CI/CD). Essa arquitetura contribuiu diretamente para o aumento da taxa de qualidade da campanha e desempenho eficiente no Google Ads.
    `,
    assets: {
      landingPreview: publicImg("perfecto/google/google-responsive.webp"),  // preview leve
      landingFull: publicImg("perfecto/google/google-desktop-big.webp"),        // imagem full
    },
  },
  {
    title: "CRM Kanban para Gestão de Leads", 
    category: ["Micro SaaS", "IA e Automações", "Marketing Digital"],
    image: publicImg("kanban/cards-crm-kanban-480.webp"),
    description: "CRM visual em formato Kanban para organizar leads, controlar follow-ups e otimizar o processo comercial.",
    descriptionLong: `
      Sistema CRM desenvolvido para transformar o acompanhamento de leads em um processo visual, simples e organizado. 
      A interface em formato Kanban permite controlar cada etapa do funil de vendas, desde o primeiro contato até o fechamento ou perda da oportunidade. 
      O projeto foi pensado para equipes comerciais que precisam priorizar contatos, acompanhar propostas enviadas, registrar interações e evitar que leads fiquem parados no funil. 
      Com painel de prioridades, follow-ups programados e timeline individual por lead, o sistema ajuda o vendedor a manter uma rotina comercial mais produtiva e orientada à conversão.
    `,
    stackNote: `
      Stack utilizada: PHP, MySQL, JavaScript, HTML, CSS e Bootstrap, com backend estruturado para cadastro, atualização e acompanhamento dos leads em banco de dados.
      O sistema foi planejado com arquitetura evolutiva, partindo de um CRM operacional em Kanban e preparado para futuras camadas de autenticação, múltiplos usuários, múltiplas empresas e isolamento de dados por tenant.

      A modelagem do banco considera tabelas como leads, lead_events e lead_tasks, com possibilidade de expansão para tenants, users e roles, permitindo transformar o projeto em uma solução multiempresa e escalável.
      Essa estrutura cria uma base sólida para evolução futura como micro SaaS, com controle de acesso, permissões, histórico comercial, tarefas, follow-ups e automações inteligentes.
    `,
    assets: {
      landingPreview: publicImg("kanban/crm-kanban-960-responsive.webp"),  // preview leve
      landingFull: publicImg("kanban/crm-kanban-960-big.webp"),        // imagem full
    },
  },
  {
    title: "Site One Page com Pagamento Integrado",
    category: ["Web / UI", "IA e Automações"],
    image: publicImg("perfectolanguage/cards-miniaturas-480-sitelanguage.webp"),
    description: "Site otimizado, gateway de pagamento e UX.",
    descriptionLong: `
      Este projeto foi desenvolvido para a Perfecto Language, com o objetivo de oferecer uma experiência fluida, segura e intuitiva ao usuário na hora da compra. A estrutura combina layout responsivo, gateway de pagamento transparente e comunicação direta com whatsapp.
      Toda a interface foi personalizada com foco em UX, apresentando os cursos e benefícios da escola com clareza, agilidade e confiança. A automação do processo de pagamento garante rapidez na aprovação e segurança nos dados transmitidos.
    `,
    stackNote: `
    Stack utilizada: Vite.js, CSS Tailwind customizado no frontend e backend com API e sistema seguro de pagamento integrado via Asaas, deploy direto no servidor.
    `,
    assets: {
      sitePreview: publicImg("perfectolanguage/sitelanguage-desktop-960-responsivo.webp"),   // imagem leve
      siteFull: publicImg("perfectolanguage/sitelanguage-desktop-960-big.webp"),        // imagem maior
      externalUrl: "https://www.perfectoespanhol.com.br/inglesem20/",
    },    
  },
  {
    title: "Landing Page para Google Ads", 
    category: ["Landing Pages", "Marketing Digital"],
    image: publicImg("perfectolanguage/lp/cards-miniaturas-480-lp.webp"),
    description: "Página otimizada para Google Ads com foco em leads qualificados e alta conversão.",
    descriptionLong: `
      Landing page desenvolvida para campanha no Google Ads da escola Perfecto Language, com foco em conversão na base do funil. 
      Estrutura enxuta, responsiva e orientada à ação, com copy persuasiva e aplicação estratégica de palavras-chave de alta intenção. 
      Projetada para atrair leads qualificados interessados em cursos de inglês, gerando alta taxa de conversão com redução significativa no custo por clique (CPC).
    `,
    stackNote: `
      Stack utilizada: Next.js com renderização estática (SSG) para garantir velocidade de carregamento, SEO técnico otimizado e performance superior. Hospedagem em Vercel, ideal para projetos com foco em marketing digital, escalabilidade e integração contínua (CI/CD). Essa arquitetura contribuiu diretamente para o aumento da taxa de qualidade da campanha e desempenho eficiente no Google Ads.
    `,
    assets: {
      landingPreview: publicImg("perfectolanguage/lp/lplanguage-desktop-960-responsivo.webp"),  // preview leve
      landingFull: publicImg("perfectolanguage/lp/lplanguage-desktop-960-big.webp"),        // imagem full
    },
  },
  {
    title: "UIX Perfecto — Agência Digital",
    category: ["Web / UI", "IA e Automações"],
    image: publicImg("uixperfecto/cards-miniaturas-480.webp"),
    description: "Site institucional da agência com design moderno, integrações seguras e agente de IA.",
    descriptionLong: `
    O site oficial da UIX Perfecto foi projetado para comunicar de forma clara e impactante os serviços de design, tecnologia e automação da agência.
    A estrutura combina layout responsivo e de alta performance, integrações seguras com gateway de pagamento transparente, além de módulos de
    automação e um agente de IA interativo para contato inteligente com visitantes.

    Cada detalhe da interface foi desenvolvido com foco em UX, garantindo navegação intuitiva, apresentação clara dos serviços e confiança para o cliente final.
    O backend foi configurado para lidar com formulários dinâmicos, gravação de dados em banco e envio automático de e-mails autenticados.
    `,
    stackNote: `
      Stack utilizada: Frontend moderno em Vite + React + Tailwind CSS, backend em PHP com banco de dados MySQL e autenticação de e-mails via SendGrid.
      Integração com a API Asaas para geração de links de pagamento personalizados e automação de cobranças. Deploy otimizado com hospedagem escalável em ambiente seguro. 
      Arquitetura desenhada para performance, SEO on-page e escalabilidade de serviços da agência.
    `,
    assets: {
      sitePreview: publicImg("uixperfecto/site-abre-desktop-mobile.webp"),   // imagem leve
      siteFull: publicImg("uixperfecto/site-abre-desktop-big.webp"),        // imagem maior
      externalUrl: "https://www.uixperfecto.com.br/",
    },    
  },
  {
    title: "Portfolio React",
    category: ["Web / UI", "IA e Automações"],
    image: publicImg("portfolio/cards-miniaturas-480-react.webp"),
    description: "Dashboard moderno e responsivo com integração de IA e backend personalizado.",
    descriptionLong: `
      Projeto completo de portfólio profissional desenvolvido com React.js, integrando uma arquitetura moderna com navegação fluida, responsividade total e experiência otimizada em todas as telas. Inclui página interativa com agente de IA, capaz de compreender o visitante e recomendar serviços personalizados. O sistema conta ainda com formulário funcional conectado a uma API própria com gravação em banco de dados e envio automático de e-mail.
    `,
    stackNote: `
      Stack utilizada: frontend desenvolvido em React.js com estrutura modular baseada no padrão Vision UI Dashboard, estilizado com Tailwind CSS para responsividade e performance. Backend em PHP com API RESTful customizada, incluindo endpoints protegidos para gravação em banco de dados MySQL e envio automatizado de e-mails autenticados via SendGrid. O agente de IA é integrado à interface com histórico completo registrado no backend. O deploy contínuo é realizado via GitHub e Vercel, com pipeline CI/CD, garantindo performance otimizada, domínio próprio e subdomínio personalizado em ambiente de produção.
    `,
    assets: {
      landingPreview: publicImg("portfolio/criativo-modal-padrao-960-react.webp"),  // preview leve
    },
  },
  {
    title: "Campanha Meta Ads com LP e Reels", 
    category: ["Landing Pages", "Marketing Digital"],
    image: publicImg("uixperfecto/lp/cards-miniaturas-480-lpuix.webp"),
    description: "Estrutura de campanha com landing page, post e Reels para captação de leads e aumento de conversões.",
    descriptionLong: `
      Projeto desenvolvido para campanha de marketing digital com foco em captação de leads qualificados por meio de landing page, criativos para redes sociais e vídeos em formato Reels.
      A estratégia combinou uma página objetiva, responsiva e orientada à conversão com peças visuais produzidas para Meta Ads, explorando chamadas diretas, impacto visual nos primeiros segundos e comunicação alinhada à dor do público-alvo.
      Além da landing page, foram criados posts e vídeos verticais para campanha, fortalecendo a presença da marca no Instagram e ampliando os pontos de contato com potenciais clientes. A combinação entre página otimizada, criativos consistentes e campanha segmentada contribuiu para uma boa taxa de conversão e resultados positivos na geração de oportunidades comerciais.
    `,
    stackNote: `
      Stack utilizada: landing page desenvolvida com foco em performance, responsividade e experiência do usuário, utilizando estrutura frontend otimizada para carregamento rápido e navegação fluida.
      Os criativos foram produzidos com apoio de Adobe Photoshop, Adobe Premiere Pro e recursos de inteligência artificial para composição visual, edição de vídeos, adaptação de formatos e criação de peças para Meta Ads.
      A entrega contemplou materiais em diferentes formatos para campanha, incluindo imagem estática, post para Instagram, vídeo vertical em formato Reels e página de destino otimizada para conversão.
    `,
    assets: {
      landingPreview: publicImg("uixperfecto/lp/lpuix-desktop-960-responsivo.webp"),
      landingFull: publicImg("uixperfecto/lp/lpuix-desktop-960-big.webp"),
      videoLayout: "single",
      videoThumbs: [
        {
          type: "local",
          src: process.env.PUBLIC_URL + "/assets/img/video/uix_perfecto.mp4",
          thumb: publicImg("video/video-thumbail-instagram-uix.webp"),
        }
      ],
    },
  },
  {
    title: "Campanha Google Ads - Loja Física",
    category: ["Marketing Digital"],
    image: publicImg("bubblebox/cards-miniaturas-480-bubble.webp"),
    description: "Campanha local para lavanderia física com foco em Google Maps, traçar rota e aumento de fluxo na loja.",
    descriptionLong: `
      Campanha de Google Ads desenvolvida para a Lavanderia Bubble Box Enseada, no Guarujá, com foco em atrair clientes próximos ao ponto físico e estimular ações de alta intenção, como pesquisar no Google, visualizar a empresa no Maps e traçar rota até a loja.
      A estratégia foi estruturada para fortalecer a presença local da marca no Google Meu Negócio, alcançando pessoas em momentos de necessidade real, como moradores, turistas, veranistas e clientes próximos à região da Enseada que buscavam serviços de lavanderia self-service.
      O projeto priorizou conversões práticas para loja física, com destaque para ações como “Traçar rota”, chamadas pelo perfil da empresa e visitas ao local. A campanha também considerou fatores regionais, sazonalidade, comportamento de busca e intenção imediata de deslocamento, conectando mídia paga com presença física e oportunidade comercial real.
    `,
    stackNote: `
      Estratégia utilizada: Google Ads com foco em presença local, integração com o Perfil da Empresa no Google, otimização para Google Maps e ações de conversão voltadas a loja física.
      O trabalho envolveu análise de localização, comportamento do público regional, estruturação de campanha local, segmentação geográfica, seleção de termos de alta intenção e acompanhamento de métricas como visualizações, interações, cliques, chamadas e ações de “Traçar rota”.
      A comunicação foi planejada para destacar conveniência, praticidade, localização estratégica e facilidade de acesso, reforçando o posicionamento da lavanderia como solução rápida e acessível para clientes na região da Enseada, Guarujá.
    `,
    assets: {
      sitePreview: publicImg("bubblebox/criativo-modal-google-meunegocio.webp"),   // imagem leve
      siteFull: publicImg("bubblebox/criativo-modal-googlemeunegocio-big.webp"),        // imagem maior
      externalUrl: "https://www.google.com/maps?q=Lavanderia+Bubble+Box+Guarujá+-+Enseada",
    },    
  },
  {
    title: "Criação de Vídeos com Premiere",
    category: ["Vídeo", "Marketing Digital"],
    image: publicImg("video/cards-miniaturas-480-video1.webp"),
    description: "Edição profissional de vídeos em múltiplos formatos com foco em redes sociais e campanhas digitais.",
    descriptionLong: `
      Edição de vídeos com Adobe Premiere Pro voltada para conteúdo digital dinâmico e de impacto visual. O projeto contempla vídeos horizontais (YouTube) e verticais (Reels, Stories, Shorts), com cortes rápidos, transições suaves, inclusão de legendas, animações, trilhas sonoras e elementos gráficos que valorizam a mensagem da marca. Os vídeos foram otimizados para plataformas específicas, com atenção à duração ideal, proporção da tela, ritmo da narrativa e impacto visual nos primeiros segundos. O foco é gerar retenção de audiência, engajamento e performance em campanhas publicitárias ou conteúdos institucionais.
    `,
    stackNote: `
      Stack utilizada: Adobe Premiere Pro para edição principal, com suporte do Adobe After Effects para animações e transições avançadas. Algumas imagens — como personagens virtuais, cenários e elementos visuais — foram geradas por inteligência artificial. As cenas com personagens foram combinadas com fundos digitais utilizando Photoshop e técnica de chroma key. Os vídeos foram exportados em MP4 (H.264), otimizados para redes sociais e apresentações em alta resolução (Full HD e 4K), com entregas finais em formatos verticais (9:16), horizontais (16:9) e quadrados (1:1), de acordo com cada canal de veiculação.
      `,
    modalSize: "widescreen",
    assets: {
      videoThumbs: [
        {
          type: "youtube",
          src: "https://www.youtube.com/embed/gGHwhIVwT54", 
          thumb: publicImg("video/video-thumbail-youtube-site.webp"),
        },
        {
          type: "youtube",
          src: "https://www.youtube.com/embed/I6DslVNn0Jc?autoplay=1",
          thumb: publicImg("video/video-thumbail-youtube-depoimento.webp"),
        },
        {
          type: "local",
          src: process.env.PUBLIC_URL + "/assets/img/video/sequence_instagram_reels_1080x1920.mp4",
          thumb: publicImg("video/video-thumbail-instagram.webp"),
        },
        {
          type: "local",
          src: process.env.PUBLIC_URL + "/assets/img/video/uix_perfecto.mp4",
          thumb: publicImg("video/video-thumbail-instagram-uix.webp"),
        }                              
      ],
    },
  }

];

const categories = [
  "Todos",
  "Design Gráfico",
  "Web / UI",
  "Landing Pages",
  "Marketing Digital",
  "Micro SaaS",
  "IA e Automações",
];

function PortfolioPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const filterFromURL = queryParams.get("filter");

  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    if (filterFromURL && categories.includes(filterFromURL)) {
      setSelectedCategory(filterFromURL);
    }
  }, [filterFromURL]);

  const filteredItems =
  selectedCategory === "Todos"
    ? portfolioItems
    : portfolioItems.filter((item) => 
        Array.isArray(item.category)
          ? item.category.includes(selectedCategory)
          : item.category === selectedCategory
      );

  const handleOpenModal = (project) => {
    setSelectedProject(project);
    setModalOpen(true);
    window.scrollTo(0, 0);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedProject(null);
  };

  return (
    <DashboardLayout>
      <DefaultNavbar /> {/* <DashboardNavbar /> */}
      <VuiBox py={3}>
        <Card>
          <CardContent>
            <VuiBox mb={4} textAlign="center">
              <VuiTypography variant="h2" color="white" fontWeight="bold">
                Portfólio
              </VuiTypography>
              <VuiTypography variant="body2" color="text">
                Explore alguns dos projetos desenvolvidos em design, web e soluções digitais.
              </VuiTypography>
            </VuiBox>
            
            <VuiBox display="flex" flexWrap="wrap" justifyContent="center" gap={2} mb={4}>
              {categories.map((cat) => (
                <Chip
                  key={cat}
                  label={cat}
                  onClick={() => setSelectedCategory(cat)}
                  sx={chipStyle(selectedCategory === cat)}
                />
              ))}
            </VuiBox>

            <Grid container spacing={3}>
              {filteredItems.map((item, idx) => (
                <Grid item xs={12} md={6} lg={4} key={idx}>
                  <Card
                    sx={{
                      backgroundColor: "#1E1F2F",
                      borderRadius: "16px",
                      height: "100%",
                      p: 2,
                      cursor: "pointer",
                    }}
                    onClick={() => handleOpenModal(item)}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "12px",
                        marginBottom: "16px",
                      }}
                    />
                    <VuiTypography variant="h5" color="white" fontWeight="bold" mb={1}>
                      {item.title}
                    </VuiTypography>
                    <VuiTypography variant="body2" color="text">
                      {item.description}
                    </VuiTypography>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <PortfolioModal open={modalOpen} onClose={handleCloseModal} project={selectedProject} />
          </CardContent>
        </Card>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PortfolioPage;